import * as Validators from '../../../../utils/forms/validators';
import { InquiryDocumentType } from '../../../../../constants/inquiries';
import { InquiryDocument } from 'inquiries/inquiry-document.model';


export const DocumentValidators = {
  requiredForSale: (doc: InquiryDocument) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Sale' && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },
  requiredForRent: (doc: InquiryDocument) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Rent' && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },

  requiredIf: (condition: boolean) => {
    const validator: Validators.Validator = (field, form) => {
      if (condition && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },

  reqOfferSale: (doc: InquiryDocument, docType: InquiryDocumentType) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Sale' && docType === InquiryDocumentType.OFFER && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },
  reqOfferRent: (doc: InquiryDocument, docType: InquiryDocumentType) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Rent' && docType === InquiryDocumentType.OFFER && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },

  reqContractSale: (doc: InquiryDocument, docType: InquiryDocumentType) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Sale' && docType === InquiryDocumentType.CONTRACT && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },
  reqContractRent: (doc: InquiryDocument, docType: InquiryDocumentType) => {
    const validator: Validators.Validator = (field, form) => {
      if (doc.category === 'Rent' && docType === InquiryDocumentType.CONTRACT && !field.value) {
        form.isValid = field.isValid = false;
        return false;
      }
    };
    return validator;
  },
}
